import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ImageOff } from "lucide-react";
import { getImageUrl } from "src/utils/imageUrl";

const GridCard = ({ data, height = "h-[300px]", closeMenu, hideCategory = false, hideTags = false }) => {
  const [hover, setHover] = useState(false);
  const [imageError, setImageError] = useState(false);
  const currency = useSelector((state) => state.currency.currencyName);

  const handleProductClick = () => {
    if (closeMenu && typeof closeMenu === 'function') {
      closeMenu();
    }
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const productSlug = data?.slug || data?.id;
  const productPath = productSlug ? `/product/${productSlug}` : "/product";

  const currentImageUrl = hover ? getImageUrl(data?.hoverImage) : getImageUrl(data?.image);
  const shouldShowFallback = !currentImageUrl || imageError;

  return (
    <div
      className="w-full pb-3 bg-gray-100 rounded-lg relative overflow-hidden h-full"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Tags */}
      {!hideTags && (
        <div className="absolute top-[15px] left-[15px] space-x-2 flex flex-wrap gap-2 z-[100]">
          {data?.tags &&
            data?.tags.map((tag, index) => {
              const bgColor =
                tag.type === "discount"
                  ? "bg-red-600"
                  : tag.type === "highlight"
                  ? "bg-green-600"
                  : "bg-gray-800";

              return (
                <span
                  key={index}
                  className={`text-sm font-outfitRegular ${bgColor} text-white px-2 py-1 rounded-full`}
                >
                  {tag.value}
                </span>
              );
            })}
        </div>
      )}

      {/* Image */}
      <div className={`${height} relative overflow-hidden`}>
        <Link to={productPath} onClick={handleProductClick}>
          {!shouldShowFallback ? (
            <img
              src={currentImageUrl}
              alt={data?.name || "Product"}
              className="h-full w-full object-cover rounded-md cursor-pointer transform hover:scale-110 hover:rotate-1"
              style={{
                willChange: "transform",
                transition: "transform 0.8s ease-in-out",
              }}
              onError={handleImageError}
            />
          ) : (
            <div className="h-full w-full bg-gray-200 rounded-md cursor-pointer flex items-center justify-center flex-col text-gray-500 transform hover:scale-110 hover:rotate-1"
                 style={{
                   willChange: "transform",
                   transition: "transform 0.8s ease-in-out",
                 }}>
              <ImageOff size={48} className="mb-2 opacity-50" />
              <span className="text-sm font-outfitMedium">No Image</span>
            </div>
          )}
        </Link>
      </div>

      <div className="p-2 flex flex-col flex-grow">
        {/* Category/Type */}
        {!hideCategory && (
          <div className="mb-1 text-[11px] text-left font-outfitMedium text-black">
            {data?.type}
          </div>
        )}
       
       <div className="mb-1 w-full flex-grow">
        <Link
            to={productPath}
           onClick={handleProductClick}
           title={data?.name}
           // min-height reserves two lines so cards with 1- and 2-line names
           // stay the same height and their prices align across the row.
           className="text-[14px] font-outfitSemiBold cursor-pointer text-black leading-[1.2] block overflow-hidden text-ellipsis line-clamp-2 min-h-[2.4em]"
          >
          {data?.name}
         </Link>
        </div>
        {/* Push price to bottom of card */}
        <div className="mt-auto font-outfitSemiBold text-gray-900 flex space-x-2 items-center gap-1">
          <span className="text-gray-900 font-outfitBold text-[13px]">
            {`${currency}${data?.price}`}
          </span>
          {data?.oldPrice !== data?.price && (
            <span className="text-gray-500 font-outfitRegular text-[11px] line-through">
              {`${currency}${data?.oldPrice}`}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default GridCard;
